<app-menu></app-menu>

<section class="controldp-page" *ngIf="tenantId; else noAccess">
  <div class="page-guide">CONTROLPS / CONTROLOP</div>

  <div class="tab-toolbar">
    <div class="cp-tabs dp-main-tabs">
      <button
        mat-stroked-button
        type="button"
        *ngFor="let tab of visibleTabs"
        [class.active]="activeTab === tab"
        (click)="setActiveTab(tab)">
        <mat-icon>{{ tabIcons[tab] }}</mat-icon>
        {{ tabLabels[tab] }}
      </button>
    </div>

    <div class="tab-toolbar__actions">
      <button class="filter-icon-button" type="button" (click)="openFilterModal()" aria-label="Filtrar">
        <mat-icon>filter_list</mat-icon>
      </button>
      <button class="btn ghost" type="button" *ngIf="filterSectorId || filterDepartmentId || dashboardFilter !== 'ALL' || dashboardFeedbackTemplateId" (click)="clearFilters()">Limpar filtro</button>
    </div>
  </div>

  <ng-container *ngIf="activeTab === 'dashboard'">
    <section class="dashboard-v2-kpis" *ngIf="showDashboardCollaborator">
      <article class="dashboard-v2-kpi-card">
        <div class="dashboard-v2-kpi-card__head">
          <span>Total de colaboradores</span>
          <mat-icon>groups</mat-icon>
        </div>
        <strong>{{ dashboardView.total }}</strong>
        <small>Base filtrada atual</small>
      </article>
      <article class="dashboard-v2-kpi-card">
        <div class="dashboard-v2-kpi-card__head">
          <span>Ativos</span>
          <mat-icon>verified_user</mat-icon>
        </div>
        <strong>{{ dashboardView.active }}</strong>
        <small class="positive">+{{ hiresLast30Days }} admissões nos últimos 30 dias</small>
      </article>
      <article class="dashboard-v2-kpi-card">
        <div class="dashboard-v2-kpi-card__head">
          <span>Taxa de atividade</span>
          <mat-icon>donut_large</mat-icon>
        </div>
        <strong>{{ activeRateLabel }}</strong>
        <small>{{ dashboardInactiveRateLabel }} inativos na base</small>
      </article>
    </section>

    <section class="dashboard-v2-layout">
      <article class="card dashboard-v2-card dashboard-v2-card--line" *ngIf="showDashboardCollaborator">
        <header class="dashboard-v2-card__head">
          <h3>Análise de admissões (últimos {{ dashboardPeriodMonths }} meses)</h3>
          <div class="dashboard-v2-period-toggle">
            <button
              type="button"
              class="dashboard-v2-period-btn"
              *ngFor="let option of dashboardPeriodOptions"
              [class.active]="dashboardPeriodMonths === option"
              (click)="setDashboardPeriod(option)">
              {{ option }}m
            </button>
          </div>
        </header>

        <div class="dashboard-v2-line-chart" *ngIf="admissionsByMonth.length">
          <canvas
            baseChart
            class="dashboard-v2-line-chart__canvas"
            [data]="admissionsLineChartData"
            [options]="dashboardLineChartOptions"
            [type]="'line'"></canvas>
        </div>

        <div class="dashboard-v2-legend">
          <span title="Quantidade real de contratações em cada mês do período."><i class="legend-dot legend-dot--primary"></i>Admissões</span>
          <span title="Linha suavizada por média móvel de 3 meses para mostrar direção geral (queda/subida)."><i class="legend-dot legend-dot--secondary"></i>Tendência</span>
          <span title="Média simples de contratações por mês no período selecionado."><i class="legend-line legend-line--average"></i>Média {{ admissionsAveragePerMonthLabel }}/mês</span>
        </div>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--department" *ngIf="showDashboardCollaborator">
        <header class="dashboard-v2-card__head">
          <h3>Distribuição por departamento</h3>
          <span>Departamentos</span>
        </header>

        <div class="dashboard-v2-donut-wrap">
          <div class="dashboard-v2-donut" [style.background]="dashboardDepartmentDonutStyle">
            <div class="dashboard-v2-donut__inner">
              <strong>{{ dashboardDepartmentTop.count }}</strong>
              <small>{{ dashboardDepartmentTop.label }}</small>
            </div>
          </div>
          <div class="dashboard-v2-status-bars">
            <ng-container *ngFor="let row of dashboardDepartmentRows">
              <div>
                <span>{{ row.label }}</span>
                <strong>{{ row.count }} · {{ row.percent }}%</strong>
              </div>
              <div class="mini-bar">
                <div class="mini-bar__fill" [style.width.%]="row.percent" [style.background]="row.color"></div>
              </div>
            </ng-container>
            <div class="empty" *ngIf="!dashboardDepartmentRows.length">
              Sem dados de departamento para o filtro atual.
            </div>
          </div>
        </div>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--mood" *ngIf="showDashboardThermometer">
        <header class="dashboard-v2-card__head">
          <h3>Termômetro de humor dos colaboradores</h3>
          <span>Base do escopo ControlOP</span>
        </header>
        <div class="dashboard-v2-mood-chart" *ngIf="!moodSummaryLoading; else moodLoading">
          <div class="dashboard-v2-mood-summary">
            <span>Total colaboradores no escopo: <strong>{{ scopedMoodEmployeeTotal }}</strong></span>
            <span>Responderam no período: <strong>{{ moodUniqueRespondents }}</strong></span>
            <span>Taxa de resposta: <strong>{{ moodResponseRateLabel }}</strong></span>
          </div>
          <div class="dashboard-v2-mood-grid">
            <div class="dashboard-v2-mood-donut-wrap">
              <div class="dashboard-v2-mood-donut" [style.background]="moodDonutStyle">
                <div class="dashboard-v2-mood-donut__inner">
                  <strong>{{ moodSummaryTotal }}</strong>
                  <small>Respostas</small>
                </div>
              </div>
            </div>
            <div class="dashboard-v2-mood-rows">
              <div class="dashboard-v2-mood-row" *ngFor="let row of moodSummaryRows">
                <span class="mood-label">{{ row.emoji }} {{ row.label }}</span>
                <div class="mini-bar">
                  <div class="mini-bar__fill mini-bar__fill--primary" [style.width.%]="row.percent" [style.background]="moodColor(row.id)"></div>
                </div>
                <strong>{{ row.percent | number:'1.0-0' }}% · {{ row.count }}</strong>
              </div>
            </div>
          </div>
          <div class="empty" *ngIf="!moodSummaryTotal">Sem respostas de humor no período.</div>
        </div>
        <ng-template #moodLoading>
          <div class="loading">Carregando termômetro de humor...</div>
        </ng-template>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--mood-trend" *ngIf="showDashboardThermometer">
        <header class="dashboard-v2-card__head">
          <h3>Quantidade de respostas do termômetro</h3>
          <div class="dashboard-v2-period-toggle">
            <button
              type="button"
              class="dashboard-v2-period-btn"
              *ngFor="let option of moodPeriodOptions"
              [class.active]="moodPeriodMonths === option"
              (click)="setMoodPeriod(option)">
              {{ option }}m
            </button>
          </div>
        </header>
        <div class="dashboard-v2-line-chart dashboard-v2-line-chart--mood" *ngIf="!moodSummaryLoading">
          <svg viewBox="0 0 640 220" preserveAspectRatio="none" aria-hidden="true">
            <g>
              <line class="grid-line-h" x1="36" y1="34" x2="620" y2="34"></line>
              <line class="grid-line-h" x1="36" y1="85" x2="620" y2="85"></line>
              <line class="grid-line-h" x1="36" y1="136" x2="620" y2="136"></line>
              <line class="grid-line-h" x1="36" y1="188" x2="620" y2="188"></line>
            </g>
            <path class="mood-area" [attr.d]="moodTrendAreaPath"></path>
            <polyline class="line line-primary" [attr.points]="moodTrendLinePointList"></polyline>
            <polyline class="line line-secondary" [attr.points]="moodTrendRespondentPointList"></polyline>
            <ng-container *ngFor="let point of moodTrendDots">
              <circle class="dot dot-primary" [attr.cx]="point.x" [attr.cy]="point.y" r="5"></circle>
              <text class="mood-point-label" [attr.x]="point.x" [attr.y]="point.y - 10">{{ point.value }}</text>
            </ng-container>
            <ng-container *ngFor="let point of moodTrendRespondentDots">
              <circle class="dot dot-secondary" [attr.cx]="point.x" [attr.cy]="point.y" r="4"></circle>
              <text class="mood-point-label mood-point-label--secondary" [attr.x]="point.x" [attr.y]="point.y + 16">{{ point.value }}</text>
            </ng-container>
          </svg>
          <div class="dashboard-v2-line-chart__labels mood-labels">
            <span *ngFor="let item of moodMonthlyRows">{{ item.label }}</span>
          </div>
        </div>
        <div class="dashboard-v2-legend">
          <span><i class="legend-dot legend-dot--primary"></i>Respostas</span>
          <span><i class="legend-dot legend-dot--secondary"></i>Colaboradores que responderam</span>
        </div>
        <div class="loading" *ngIf="moodSummaryLoading">Carregando termômetro de humor...</div>
        <div class="empty" *ngIf="!moodSummaryLoading && !moodMonthlyRows.length">Sem respostas no período selecionado.</div>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--mood-gender" *ngIf="showDashboardThermometer">
        <header class="dashboard-v2-card__head">
          <h3>Respostas por gênero</h3>
          <span>{{ moodPeriodMonths }}m</span>
        </header>
        <div class="dashboard-v2-mood-gender" *ngIf="!moodSummaryLoading">
          <div class="dashboard-v2-mood-gender-donut" [style.background]="moodGenderDonutStyle">
            <div class="dashboard-v2-mood-gender-donut__inner">
              <strong>{{ moodSummaryTotal }}</strong>
              <small>Total</small>
            </div>
          </div>
          <div class="chart-list compact">
            <div class="chart-row" *ngFor="let item of moodGenderRows">
              <span class="mood-gender-label">
                <i class="mood-gender-dot" [style.background]="moodGenderColor(item.key)"></i>
                {{ item.label }}
              </span>
              <div class="bar">
                <div class="bar-fill" [style.width.%]="getBarPercent(item.count, moodGenderMax)" [style.background]="moodGenderColor(item.key)"></div>
              </div>
              <strong>{{ item.count }} · {{ item.percent }}%</strong>
            </div>
          </div>
        </div>
        <div class="loading" *ngIf="moodSummaryLoading">Carregando termômetro de humor...</div>
        <div class="empty" *ngIf="!moodSummaryLoading && !moodGenderRows.length">Sem dados por gênero no período.</div>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--mood-department" *ngIf="showDashboardThermometer">
        <header class="dashboard-v2-card__head">
          <h3>Respostas por departamento</h3>
          <span>{{ moodPeriodMonths }}m</span>
        </header>
        <div class="chart-list scrollable compact" *ngIf="!moodSummaryLoading">
          <div class="chart-row" *ngFor="let item of moodDepartmentRows">
            <span>{{ item.label }}</span>
            <div class="bar bar--stacked">
              <div class="bar-fill bar-fill--positive" [style.width.%]="getDepartmentMoodSegmentPercent(item, 'positive')"></div>
              <div class="bar-fill bar-fill--neutral" [style.width.%]="getDepartmentMoodSegmentPercent(item, 'neutral')"></div>
              <div class="bar-fill bar-fill--negative" [style.width.%]="getDepartmentMoodSegmentPercent(item, 'negative')"></div>
            </div>
            <strong>{{ item.count }} · {{ item.percent }}%</strong>
          </div>
          <div class="dashboard-v2-legend">
            <span><i class="legend-dot legend-dot--positive"></i>Excelente + Bom</span>
            <span><i class="legend-dot legend-dot--neutral"></i>Neutro</span>
            <span><i class="legend-dot legend-dot--negative"></i>Triste + Péssimo</span>
          </div>
          <div class="empty" *ngIf="!moodDepartmentRows.length">Sem dados por departamento no período.</div>
        </div>
        <div class="loading" *ngIf="moodSummaryLoading">Carregando termômetro de humor...</div>
      </article>

      <article class="card dashboard-v2-card dashboard-v2-card--feedback" *ngIf="showDashboardFeedback">
        <header class="dashboard-v2-card__head">
          <h3>Dashboard de feedback</h3>
          <span>{{ selectedDashboardFeedbackTemplateLabel }}</span>
        </header>
        <div class="dashboard-v2-feedback-grid" *ngIf="!feedbackDashboardLoading; else feedbackLoading">
          <div class="dashboard-v2-feedback-kpi">
            <small>Total de registros</small>
            <strong>{{ feedbackDashboardSummary.total }}</strong>
          </div>
          <div class="dashboard-v2-feedback-kpi">
            <small>Aplicados</small>
            <strong>{{ feedbackDashboardSummary.applied }}</strong>
          </div>
          <div class="dashboard-v2-feedback-kpi">
            <small>Agendados</small>
            <strong>{{ feedbackDashboardSummary.scheduled }}</strong>
          </div>
          <div class="dashboard-v2-feedback-kpi">
            <small>Rascunhos</small>
            <strong>{{ feedbackDashboardSummary.draft }}</strong>
          </div>
          <div class="dashboard-v2-feedback-kpi">
            <small>Colaboradores únicos</small>
            <strong>{{ feedbackDashboardSummary.unique_employees }}</strong>
          </div>
          <div class="dashboard-v2-feedback-kpi">
            <small>Taxa de aplicação</small>
            <strong>{{ feedbackDashboardSummary.applied_rate || 0 }}%</strong>
          </div>
        </div>
        <ng-template #feedbackLoading>
          <div class="loading">Carregando indicadores de feedback...</div>
        </ng-template>
      </article>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'collaborators'">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Colaboradores</h2>
          <p>Cadastre e acompanhe o histórico completo de cada colaborador.</p>
        </div>
        <div class="panel-actions">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field cp-search-field--table op-table-search-field">
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              type="text"
              placeholder="Pesquise o colaborador..."
              aria-label="Pesquisar colaborador"
              [(ngModel)]="filterTerm"
              (ngModelChange)="currentPage = 1">
          </mat-form-field>
        </div>
      </div>

      <div class="table-wrapper" *ngIf="!loading">
        <table>
          <thead>
            <tr>
              <th>Colaborador</th>
              <th>Matrícula</th>
              <th>Cargo</th>
              <th>Setor</th>
              <th>Status</th>
              <th>Admissão</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let emp of pagedEmployees">
              <td>
                <strong>{{ emp.full_name }}</strong>
                <small>{{ emp.cpf || 'Sem CPF' }}</small>
              </td>
              <td>{{ emp.employee_code || '—' }}</td>
              <td class="role-cell">{{ emp.role_name || '—' }}</td>
              <td class="sector-cell">{{ emp.sector_name || emp.department_name || '—' }}</td>
              <td>
                <span class="status-pill" [ngClass]="emp.status?.toLowerCase()">{{ emp.status }}</span>
              </td>
              <td>{{ emp.hired_at ? (emp.hired_at | date:'shortDate') : '—' }}</td>
              <td class="actions">
                <button type="button" class="action-icon" title="Editar" aria-label="Editar" (click)="openEmployeeModal(emp)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" class="action-icon" title="Ocorrência" aria-label="Ocorrência" (click)="openOccurrenceModal(emp)">
                  <mat-icon>event_note</mat-icon>
                </button>
                <button type="button" class="action-icon" title="Aplicar feedback" aria-label="Aplicar feedback" (click)="openEmployeeFeedbackModal(emp)">
                  <mat-icon>rate_review</mat-icon>
                </button>
                <button type="button" class="action-icon" title="Histórico" aria-label="Histórico" (click)="openHistoryModal(emp)">
                  <mat-icon>history</mat-icon>
                </button>
              </td>
            </tr>
            <tr *ngIf="!filteredEmployees.length">
              <td colspan="7" class="empty">Nenhum colaborador cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-pagination" *ngIf="filteredEmployees.length > pageSize">
        <button type="button" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">Anterior</button>
        <span>Página {{ currentPage }} de {{ totalPages }}</span>
        <button type="button" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">Próxima</button>
      </div>
      <div class="loading" *ngIf="loading">Carregando colaboradores...</div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'imports' && isAdmin">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Importações</h2>
          <p>Importe bases de colaboradores, faltas e atrasos com preview antes de salvar.</p>
        </div>
      </div>

      <div class="import-cards">
        <article class="import-card" *ngFor="let card of importCards">
          <div>
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
          <div class="import-actions">
            <button class="btn ghost" type="button" (click)="downloadImportTemplate(card.key)">
              Baixar modelo
            </button>
            <button class="btn primary" type="button" (click)="openImportModal(card.key)">
              Selecionar planilha
            </button>
          </div>
        </article>
      </div>

      <div class="import-lookups">
        <h3>Planilhas de referência</h3>
        <div class="lookup-actions">
          <button class="btn ghost" type="button" [disabled]="exportLoading" (click)="downloadLookupSheet('sectors')">
            Baixar setores (id, nome)
          </button>
          <button class="btn ghost" type="button" [disabled]="exportLoading" (click)="downloadLookupSheet('departments')">
            Baixar departamentos (id, setor_id, nome)
          </button>
          <button class="btn ghost" type="button" [disabled]="exportLoading" (click)="downloadLookupSheet('roles')">
            Baixar cargos (id, tenant_id, nome)
          </button>
        </div>
      </div>

      <div class="import-list">
        <h3>Histórico de importações</h3>
        <div class="import-history-list" *ngIf="imports.length; else emptyImports">
          <article class="import-history-card" *ngFor="let imp of imports">
            <div class="import-history-main">
              <div>
                <strong>{{ imp.import_type }}</strong>
                <small>{{ imp.file_name || 'Sem arquivo' }}</small>
              </div>
              <span class="status-pill" [ngClass]="(imp.status || '').toLowerCase()">{{ imp.status }}</span>
            </div>
            <div class="import-history-meta">
              <div>
                <span>Processados</span>
                <strong>{{ imp.processed_count ?? 0 }}</strong>
              </div>
              <div>
                <span>Erros</span>
                <strong>{{ imp.error_count ?? 0 }}</strong>
              </div>
              <div>
                <span>Restantes</span>
                <strong>{{ imp.pending_count ?? 0 }}</strong>
              </div>
              <div>
                <span>Linhas</span>
                <strong>{{ imp.total_rows }}</strong>
              </div>
              <div>
                <span>Data</span>
                <strong>{{ imp.created_at ? (imp.created_at | date:'short') : '—' }}</strong>
              </div>
            </div>
            <div class="import-history-actions" *ngIf="(imp.error_count ?? 0) > 0">
              <button class="btn ghost" type="button" (click)="downloadFailedImportRows(imp)">
                Baixar linhas com erro
              </button>
            </div>
          </article>
        </div>
        <ng-template #emptyImports>
          <div class="empty">Nenhuma importação registrada.</div>
        </ng-template>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'business'">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Detalhes do negócio</h2>
          <p>Cadastre atividades e detalhes operacionais do negócio.</p>
        </div>
        <div class="panel-actions">
          <button class="btn primary" type="button" (click)="openBusinessModal()">Cadastrar atividade</button>
        </div>
      </div>
      <div class="business-list" *ngIf="filteredBusinessActivities.length; else emptyBusiness">
        <article class="business-card" *ngFor="let item of filteredBusinessActivities">
          <div class="business-header">
            <div>
              <strong>{{ item.title || 'Sem título' }}</strong>
              <p>{{ item.description || 'Sem descrição' }}</p>
            </div>
            <div class="business-actions">
              <button class="btn ghost" type="button" (click)="openBusinessView(item)">Visualizar</button>
              <button class="btn ghost" type="button" (click)="openBusinessEdit(item)">Editar</button>
              <button class="btn ghost" type="button" (click)="openBusinessHistory(item)">Historico</button>
            </div>
          </div>
          <div class="business-meta">
            <span>Modelo: {{ item.business_model || '—' }}</span>
            <span>Jornada: {{ item.journey || '—' }}</span>
            <span>SLA: {{ item.sla || '—' }}</span>
          </div>
        </article>
      </div>
      <ng-template #emptyBusiness>
        <div class="empty" *ngIf="filterSectorId || filterDepartmentId">Nenhuma atividade encontrada para o filtro.</div>
        <div class="empty" *ngIf="!filterSectorId && !filterDepartmentId">Nenhuma atividade cadastrada.</div>
      </ng-template>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'forecast'">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Forecast</h2>
          <p>Previsoes e acompanhamento de volumes.</p>
        </div>
        <div class="panel-actions">
          <div class="search-box">
            <mat-icon>search</mat-icon>
            <input type="text" placeholder="Buscar forecast" [(ngModel)]="forecastSearchTerm">
          </div>
          <button class="btn primary" type="button" (click)="openForecastModal()">Cadastrar forecast</button>
        </div>
      </div>
      <div class="form-feedback forecast-page-feedback" *ngIf="forecastPageFeedback" [ngClass]="forecastPageFeedbackKind">
        {{ forecastPageFeedback }}
      </div>
      <div class="forecast-list" *ngIf="filteredForecasts.length; else emptyForecast">
        <article class="forecast-card" *ngFor="let item of filteredForecasts">
          <div class="forecast-main">
            <div>
              <strong>{{ item.title || 'Sem titulo' }}</strong>
              <small>{{ item.created_at ? (item.created_at | date:'short') : '—' }}</small>
            </div>
            <div class="forecast-actions">
              <button class="btn ghost" type="button" (click)="openForecastEdit(item)">Editar</button>
              <button class="btn ghost" type="button" (click)="openForecastHistory(item)">Historico</button>
            </div>
          </div>
          <div class="forecast-activity-strip" *ngIf="item.activities?.length">
            <div class="forecast-activity-row" *ngFor="let activity of item.activities">
              <div class="forecast-activity-name">
                <span>Atividade</span>
                <strong>{{ activity.activity_title || 'Geral' }}</strong>
              </div>
              <div class="forecast-activity-metric">
                <span>Recebido</span>
                <strong>{{ activity.received_date ? (activity.received_date | date:'shortDate') : '—' }}</strong>
              </div>
              <div class="forecast-activity-metric">
                <span>Referencia</span>
                <strong>{{ activity.reference_month ? (activity.reference_month | date:'MMM yyyy') : '—' }}</strong>
              </div>
              <div class="forecast-activity-metric">
                <span>Mes</span>
                <strong>{{ activity.forecast_month ?? '—' }}</strong>
              </div>
              <div class="forecast-activity-metric">
                <span>Semana</span>
                <strong>{{ activity.forecast_week ?? '—' }}</strong>
              </div>
              <div class="forecast-activity-metric">
                <span>Dia</span>
                <strong>{{ activity.forecast_day ?? '—' }}</strong>
              </div>
              <div class="forecast-activity-metric">
                <span>Hora</span>
                <strong>{{ activity.forecast_hour ?? '—' }}</strong>
              </div>
            </div>
          </div>
        </article>
      </div>
      <ng-template #emptyForecast>
        <div class="empty" *ngIf="forecasts.length && (forecastSearchTerm || filterSectorId || filterDepartmentId)">
          Nenhum forecast encontrado.
        </div>
        <div class="empty" *ngIf="!forecasts.length">Nenhum forecast cadastrado.</div>
      </ng-template>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'closing'">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Fechamento</h2>
          <p>Consolidacao e fechamento do periodo.</p>
        </div>
        <div class="panel-actions">
          <button class="btn primary" type="button" (click)="openClosingModal()">Cadastrar fechamento</button>
        </div>
      </div>
      <div class="closing-list" *ngIf="filteredClosings.length; else emptyClosing">
        <article class="closing-card" *ngFor="let item of filteredClosings">
          <div class="closing-row">
            <div class="closing-info">
              <strong>{{ getDepartmentLabel(item.department_id) }}</strong>
              <small>{{ item.closing_date ? (item.closing_date | date:'shortDate') : '—' }}</small>
            </div>
            <div class="closing-metrics">
              <div>
                <span>Meta</span>
                <strong>{{ item.goal ?? '—' }}</strong>
              </div>
              <div>
                <span>Realizado</span>
                <strong>{{ item.achieved ?? '—' }}</strong>
              </div>
              <div>
                <span>% entrega</span>
                <strong>{{ item.delivery_percent ?? '—' }}</strong>
              </div>
            </div>
            <p class="closing-notes" *ngIf="item.notes">{{ item.notes }}</p>
            <div class="closing-actions">
              <button class="btn ghost" type="button" (click)="openClosingModal(item)">Editar</button>
            </div>
          </div>
        </article>
      </div>
      <ng-template #emptyClosing>
        <div class="empty" *ngIf="filterSectorId || filterDepartmentId">Nenhum fechamento encontrado para o filtro.</div>
        <div class="empty" *ngIf="!filterSectorId && !filterDepartmentId">Nenhum fechamento cadastrado.</div>
      </ng-template>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'reports'">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Relatórios</h2>
          <p>Gere relatórios em PDF para acompanhar indicadores e fechamentos.</p>
        </div>
      </div>
      <div class="reports-grid">
        <article class="reports-card">
          <h4>Raio X do negócio</h4>
          <p>Resumo completo do departamento com indicadores, detalhes do negócio e forecast.</p>
          <div class="cp-form-row">
            <label>Departamento
              <select [(ngModel)]="reportBusinessDepartmentId">
                <option value="">Selecione</option>
                <option *ngFor="let dept of scopedDepartmentsForControlopForms" [value]="dept.id">
                  {{ getDepartmentLabel(dept.id) }}
                </option>
              </select>
            </label>
          </div>
          <div class="card-actions">
            <button class="btn primary" type="button" (click)="generateBusinessReport()">Baixar PDF</button>
          </div>
        </article>
        <article class="reports-card">
          <h4>Relatório de fechamento</h4>
          <p>Resumo por departamento com os fechamentos registrados no sistema.</p>
          <div class="cp-form-row">
            <label>Departamento
              <select [(ngModel)]="reportClosingDepartmentId">
                <option value="all">Todos</option>
                <option *ngFor="let dept of scopedDepartmentsForControlopForms" [value]="dept.id">
                  {{ getDepartmentLabel(dept.id) }}
                </option>
              </select>
            </label>
            <label>Data do fechamento
              <input type="date" [(ngModel)]="reportClosingDate">
            </label>
          </div>
          <div class="card-actions">
            <button class="btn primary" type="button" (click)="generateClosingReport()">Baixar PDF</button>
          </div>
        </article>
      </div>
      <div class="form-feedback" *ngIf="reportFeedback" [ngClass]="reportFeedbackKind">
        {{ reportFeedback }}
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="activeTab === 'extras'">
    <section class="panel card">
      <div class="panel-header">
        <div>
          <h2>Informações adicionais</h2>
          <p>Campos complementares por colaborador e visão dos departamentos habilitados.</p>
        </div>
      </div>
      <div class="extras-grid">
        <article class="extras-card">
          <h4>Departamentos habilitados</h4>
          <p *ngIf="!hasControlopScope">Nenhum departamento definido para este usuário.</p>
          <ul *ngIf="hasControlopScope">
            <li *ngFor="let dept of scopedDepartmentsForExtras">{{ dept.name }}</li>
          </ul>
        </article>
        <article class="extras-card">
          <h4>Locais habilitados</h4>
          <p *ngIf="!hasControlopScope">Nenhum local definido para este usuário.</p>
          <ul *ngIf="hasControlopScope">
            <li *ngFor="let loc of scopedLocationsForExtras">{{ loc.name }}</li>
          </ul>
        </article>
      </div>
    </section>
  </ng-container>
</section>

<ng-template #noAccess>
  <section class="empty-state">
    <p>Faça login para acessar o ControlOP.</p>
  </section>
</ng-template>

<div class="modal-backdrop" *ngIf="showFilterModal" (click)="closeFilterModal()"></div>
<aside class="side-modal filter-modal" *ngIf="showFilterModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>Filtros</h2>
      <p>Refine colaboradores e dashboards do ControlOP.</p>
    </div>
    <button type="button" class="close" (click)="closeFilterModal()">&times;</button>
  </header>
  <div class="cp-modal__body">
    <h4 class="filter-section-title">Filtro colaboradores</h4>
    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
      <mat-label>Setor</mat-label>
      <mat-select [(ngModel)]="filterSectorId" (ngModelChange)="onFilterSectorChange()">
        <mat-option value="">Todos</mat-option>
        <mat-option *ngFor="let sector of scopedSectors" [value]="sector.id">{{ sector.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
      <mat-label>Departamento</mat-label>
      <mat-select [(ngModel)]="filterDepartmentId">
        <mat-option value="">Todos</mat-option>
        <mat-option *ngFor="let dept of availableFilterDepartments" [value]="dept.id">{{ dept.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <h4 class="filter-section-title">Filtro dashboards</h4>
    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
      <mat-label>Tipo de dashboard</mat-label>
      <mat-select [(ngModel)]="dashboardFilter" (ngModelChange)="onDashboardFilterChange()">
        <mat-option *ngFor="let option of dashboardFilterOptions" [value]="option.value">{{ option.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="digital-field modal-standard-field"
      *ngIf="dashboardFilter === 'FEEDBACK'">
      <mat-label>Feedback (subfiltro)</mat-label>
      <mat-select [(ngModel)]="dashboardFeedbackTemplateId" (ngModelChange)="onDashboardFeedbackTemplateChange()">
        <mat-option value="">Todos os feedbacks</mat-option>
        <mat-option *ngFor="let template of feedbackTemplates" [value]="template.id">{{ template.title }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="clearFilters()">Limpar</button>
    <button class="btn primary" type="button" (click)="applyFilters()">Aplicar filtros</button>
  </div>
</aside>

<div class="modal-backdrop" *ngIf="showBusinessModal" (click)="closeBusinessModal()"></div>
<section class="modal wide" *ngIf="showBusinessModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>Cadastrar atividade</h2>
      <p>Preencha os dados principais do negócio.</p>
    </div>
    <button type="button" class="close" (click)="closeBusinessModal()">&times;</button>
  </header>
  <div class="cp-modal__body">
    <div class="section-card">
      <button type="button" class="section-toggle" (click)="toggleBusinessSection('details')">
        <span>Detalhes</span>
        <mat-icon>{{ showBusinessDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <div class="section-body" *ngIf="showBusinessDetails">
        <div class="cp-form-row">
          <label>Titulo
            <input type="text" [(ngModel)]="businessForm.title">
          </label>
          <label>Modelo do negocio
            <select [(ngModel)]="businessForm.business_model">
              <option value="">Selecione</option>
              <option *ngFor="let option of businessModelOptions" [value]="option">{{ option }}</option>
            </select>
          </label>
          <label>Jornada
            <input type="text" [(ngModel)]="businessForm.journey">
          </label>
          <label>Departamento
            <select [(ngModel)]="businessForm.department_id">
              <option value="">Selecione</option>
              <option *ngFor="let dept of scopedDepartmentsForControlopForms" [value]="dept.id">
                {{ getDepartmentLabel(dept.id) }}
              </option>
            </select>
          </label>
          <label>Descricao da atividade
            <textarea rows="3" [(ngModel)]="businessForm.description"></textarea>
          </label>
          <label>SLA
            <textarea rows="3" [(ngModel)]="businessForm.sla"></textarea>
          </label>
        </div>
      </div>
    </div>

    <div class="section-card">
      <button type="button" class="section-toggle" (click)="toggleBusinessSection('times')">
        <span>Tempos</span>
        <mat-icon>{{ showBusinessTimes ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <div class="section-body" *ngIf="showBusinessTimes">
        <div class="inline-grid">
          <label>TMA
            <input type="time" step="60" [(ngModel)]="businessForm.tma">
          </label>
          <label>TME
            <input type="time" step="60" [(ngModel)]="businessForm.tme">
          </label>
          <label>TMO
            <input type="time" step="60" [(ngModel)]="businessForm.tmo">
          </label>
          <label>TMC
            <input type="time" step="60" [(ngModel)]="businessForm.tmc">
          </label>
        </div>
      </div>
    </div>

    <div class="section-card">
      <button type="button" class="section-toggle" (click)="toggleBusinessSection('processes')">
        <span>Processos</span>
        <mat-icon>{{ showBusinessProcesses ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <div class="section-body" *ngIf="showBusinessProcesses">
        <div class="cp-form-row">
          <label>Processos
            <input type="file" (change)="onBusinessFileSelected('process', $event)">
            <small *ngIf="businessProcessFile">{{ businessProcessFile.name }}</small>
            <div class="file-links" *ngIf="businessExistingProcessAttachment">
              <a [href]="formatAttachmentUrl(businessExistingProcessAttachment.path)" target="_blank" rel="noopener">
                {{ businessExistingProcessAttachment.name || 'Arquivo atual' }}
              </a>
            </div>
          </label>
          <label>M.E.O
            <input type="file" (change)="onBusinessFileSelected('meo', $event)">
            <small *ngIf="businessMeoFile">{{ businessMeoFile.name }}</small>
            <div class="file-links" *ngIf="businessExistingMeoAttachment">
              <a [href]="formatAttachmentUrl(businessExistingMeoAttachment.path)" target="_blank" rel="noopener">
                {{ businessExistingMeoAttachment.name || 'Arquivo atual' }}
              </a>
            </div>
          </label>
          <label>Outros
            <input type="file" multiple (change)="onBusinessFileSelected('others', $event)">
            <small *ngIf="businessOtherProcessAttachments.length">{{ businessOtherProcessAttachments.length }} arquivo(s) selecionado(s)</small>
          </label>
          <ul class="file-list" *ngIf="businessExistingOtherAttachments.length">
            <li *ngFor="let file of businessExistingOtherAttachments">
              <a [href]="formatAttachmentUrl(file.path)" target="_blank" rel="noopener">
                {{ file.name || file.path }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="section-card">
      <button type="button" class="section-toggle" (click)="toggleBusinessSection('systems')">
        <span>Sistemas</span>
        <mat-icon>{{ showBusinessSystems ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <div class="section-body" *ngIf="showBusinessSystems">
        <div class="cp-form-row">
          <div class="field">
            <span class="field-label">Sistemas cliente</span>
            <div class="tag-input">
              <span class="tag" *ngFor="let item of businessClientSystems">
                {{ item }} <button type="button" (click)="removeBusinessKeyword('client', item)">x</button>
              </span>
              <input type="text"
                     placeholder="Adicionar e pressionar Enter"
                     [(ngModel)]="businessClientInput"
                     (keydown.enter)="$event.preventDefault(); addBusinessKeyword('client')">
            </div>
          </div>
          <div class="field">
            <span class="field-label">Sistemas internos</span>
            <div class="tag-input">
              <span class="tag" *ngFor="let item of businessAcertSystems">
                {{ item }} <button type="button" (click)="removeBusinessKeyword('acert', item)">x</button>
              </span>
              <input type="text"
                     placeholder="Adicionar e pressionar Enter"
                     [(ngModel)]="businessAcertInput"
                     (keydown.enter)="$event.preventDefault(); addBusinessKeyword('acert')">
            </div>
          </div>
          <div class="field">
            <span class="field-label">Sistemas fornecedores</span>
            <div class="tag-input">
              <span class="tag" *ngFor="let item of businessSupplierSystems">
                {{ item }} <button type="button" (click)="removeBusinessKeyword('supplier', item)">x</button>
              </span>
              <input type="text"
                     placeholder="Adicionar e pressionar Enter"
                     [(ngModel)]="businessSupplierInput"
                     (keydown.enter)="$event.preventDefault(); addBusinessKeyword('supplier')">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-card">
      <button type="button" class="section-toggle" (click)="toggleBusinessSection('manuals')">
        <span>Manuais</span>
        <mat-icon>{{ showBusinessManuals ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      <div class="section-body" *ngIf="showBusinessManuals">
        <div class="cp-form-row">
          <label>Anexos
            <input type="file" multiple (change)="onBusinessFileSelected('manuals', $event)">
            <small *ngIf="businessManualAttachments.length">{{ businessManualAttachments.length }} arquivo(s) selecionado(s)</small>
          </label>
        </div>
        <ul class="file-list" *ngIf="businessExistingManualAttachments.length">
          <li *ngFor="let file of businessExistingManualAttachments">
            <a [href]="formatAttachmentUrl(file.path)" target="_blank" rel="noopener">
              {{ file.name || file.path }}
            </a>
          </li>
        </ul>
        <ul class="file-list" *ngIf="businessManualAttachments.length">
          <li *ngFor="let file of businessManualAttachments">{{ file.name }}</li>
        </ul>
      </div>
    </div>

    <div class="full-width">
      <label>Observacao
        <textarea rows="4" [(ngModel)]="businessForm.observations"></textarea>
      </label>
    </div>
  </div>
  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="closeBusinessModal()">Cancelar</button>
    <button class="btn ghost" type="button" (click)="fillBusinessTestData()">Preencher automaticamente</button>
    <button class="btn primary" type="button" (click)="submitBusinessActivity()">Salvar atividade</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showBusinessHistoryModal" (click)="closeBusinessHistoryModal()"></div>
<section class="modal" *ngIf="showBusinessHistoryModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>Historico</h2>
      <p>Alteracoes e insercoes registradas.</p>
    </div>
    <button type="button" class="close" (click)="closeBusinessHistoryModal()">&times;</button>
  </header>
  <div class="cp-modal__body">
    <div class="history-list" *ngIf="selectedBusinessHistory.length; else emptyBusinessHistory">
      <article class="history-item" *ngFor="let item of selectedBusinessHistory">
        <div class="history-head">
          <strong>{{ item.action === 'create' ? 'Criado' : 'Atualizado' }}</strong>
          <small>{{ item.at | date:'short' }} · {{ item.user_name }}</small>
        </div>
        <p>{{ item.after?.title || item.before?.title || 'Sem titulo' }}</p>
        <div class="history-diff" *ngIf="item.changes?.length">
          <div class="diff-row" *ngFor="let change of item.changes">
            <span class="diff-label">{{ change.label }}</span>
            <span class="diff-before">{{ change.before || '—' }}</span>
            <span class="diff-after">{{ change.after || '—' }}</span>
          </div>
        </div>
        <p *ngIf="!item.changes?.length && item.action === 'create'">Registro inicial.</p>
      </article>
    </div>
    <ng-template #emptyBusinessHistory>
      <div class="empty">Nenhuma alteracao registrada.</div>
    </ng-template>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showBusinessViewModal" (click)="closeBusinessViewModal()"></div>
<section class="modal wide business-view-modal" *ngIf="showBusinessViewModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>Detalhes da atividade</h2>
      <p>{{ selectedBusinessView?.title || 'Atividade sem titulo' }}</p>
    </div>
    <button type="button" class="close" (click)="closeBusinessViewModal()">&times;</button>
  </header>
  <div class="cp-modal__body">
    <div class="business-view-grid">
      <div class="view-card">
        <h3>Resumo</h3>
        <div class="view-row">
          <span>Modelo</span>
          <strong>{{ selectedBusinessView?.business_model || '—' }}</strong>
        </div>
        <div class="view-row">
          <span>Jornada</span>
          <strong>{{ selectedBusinessView?.journey || '—' }}</strong>
        </div>
        <div class="view-row">
          <span>Departamento</span>
          <strong>{{ getDepartmentLabel(selectedBusinessView?.department_id) }}</strong>
        </div>
        <div class="view-row">
          <span>SLA</span>
          <strong>{{ selectedBusinessView?.sla || '—' }}</strong>
        </div>
      </div>

      <div class="view-card">
        <h3>Tempos</h3>
        <div class="view-row">
          <span>TMA</span>
          <strong>{{ formatTimeLabel(selectedBusinessView?.tma) }}</strong>
        </div>
        <div class="view-row">
          <span>TME</span>
          <strong>{{ formatTimeLabel(selectedBusinessView?.tme) }}</strong>
        </div>
        <div class="view-row">
          <span>TMO</span>
          <strong>{{ formatTimeLabel(selectedBusinessView?.tmo) }}</strong>
        </div>
        <div class="view-row">
          <span>TMC</span>
          <strong>{{ formatTimeLabel(selectedBusinessView?.tmc) }}</strong>
        </div>
      </div>

      <div class="view-card full">
        <h3>Descricao</h3>
        <p class="view-text">{{ selectedBusinessView?.description || 'Sem descricao.' }}</p>
      </div>

      <div class="view-card">
        <h3>Sistemas cliente</h3>
        <div class="view-tags" *ngIf="selectedBusinessView?.client_systems?.length; else noClientSystems">
          <span class="view-tag" *ngFor="let item of selectedBusinessView?.client_systems">{{ item }}</span>
        </div>
        <ng-template #noClientSystems>
          <p class="muted">Nenhum sistema informado.</p>
        </ng-template>
      </div>

      <div class="view-card">
        <h3>Sistemas internos</h3>
        <div class="view-tags" *ngIf="selectedBusinessView?.acert_systems?.length; else noInternalSystems">
          <span class="view-tag" *ngFor="let item of selectedBusinessView?.acert_systems">{{ item }}</span>
        </div>
        <ng-template #noInternalSystems>
          <p class="muted">Nenhum sistema informado.</p>
        </ng-template>
      </div>

      <div class="view-card">
        <h3>Sistemas fornecedores</h3>
        <div class="view-tags" *ngIf="selectedBusinessView?.supplier_systems?.length; else noSupplierSystems">
          <span class="view-tag" *ngFor="let item of selectedBusinessView?.supplier_systems">{{ item }}</span>
        </div>
        <ng-template #noSupplierSystems>
          <p class="muted">Nenhum sistema informado.</p>
        </ng-template>
      </div>

      <div class="view-card full">
        <h3>Anexos</h3>
        <div class="attachment-grid">
          <div class="attachment-group">
            <span class="group-title">Processos</span>
            <div class="view-links" *ngIf="selectedBusinessView?.process_attachment; else noProcessAttachment">
              <a
                class="view-link"
                [href]="formatAttachmentUrl(selectedBusinessView?.process_attachment?.path)"
                target="_blank"
                rel="noopener"
              >
                {{ selectedBusinessView?.process_attachment?.name || 'Arquivo' }}
              </a>
            </div>
            <ng-template #noProcessAttachment>
              <p class="muted">Nenhum anexo.</p>
            </ng-template>
          </div>
          <div class="attachment-group">
            <span class="group-title">M.E.O</span>
            <div class="view-links" *ngIf="selectedBusinessView?.meo_attachment; else noMeoAttachment">
              <a
                class="view-link"
                [href]="formatAttachmentUrl(selectedBusinessView?.meo_attachment?.path)"
                target="_blank"
                rel="noopener"
              >
                {{ selectedBusinessView?.meo_attachment?.name || 'Arquivo' }}
              </a>
            </div>
            <ng-template #noMeoAttachment>
              <p class="muted">Nenhum anexo.</p>
            </ng-template>
          </div>
          <div class="attachment-group">
            <span class="group-title">Outros</span>
            <div class="view-links" *ngIf="selectedBusinessView?.other_attachments?.length; else noOtherAttachments">
              <a
                class="view-link"
                *ngFor="let file of selectedBusinessView?.other_attachments"
                [href]="formatAttachmentUrl(file?.path)"
                target="_blank"
                rel="noopener"
              >
                {{ file?.name || file?.path || 'Arquivo' }}
              </a>
            </div>
            <ng-template #noOtherAttachments>
              <p class="muted">Nenhum anexo.</p>
            </ng-template>
          </div>
          <div class="attachment-group">
            <span class="group-title">Manuais</span>
            <div class="view-links" *ngIf="selectedBusinessView?.manual_attachments?.length; else noManualAttachments">
              <a
                class="view-link"
                *ngFor="let file of selectedBusinessView?.manual_attachments"
                [href]="formatAttachmentUrl(file?.path)"
                target="_blank"
                rel="noopener"
              >
                {{ file?.name || file?.path || 'Arquivo' }}
              </a>
            </div>
            <ng-template #noManualAttachments>
              <p class="muted">Nenhum anexo.</p>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="view-card full">
        <h3>Observacoes</h3>
        <p class="view-text">{{ selectedBusinessView?.observations || 'Sem observacoes.' }}</p>
      </div>
    </div>
  </div>
  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="closeBusinessViewModal()">Fechar</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showForecastModal" (click)="closeForecastModal()"></div>
<section class="modal wide" *ngIf="showForecastModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>{{ editingForecastId ? 'Editar forecast' : 'Cadastrar forecast' }}</h2>
      <p>Preencha os dados principais e os volumes previstos.</p>
    </div>
    <button type="button" class="close" (click)="closeForecastModal()">&times;</button>
  </header>
  <div class="cp-modal__body">
    <div class="forecast-intro">
      <div class="cp-form-row">
      <label>Titulo
        <input type="text" [(ngModel)]="forecastForm.title">
      </label>
    </div>
    <div class="form-error" *ngIf="forecastValidationError">{{ forecastValidationError }}</div>
    <div class="form-feedback" *ngIf="forecastFeedback" [ngClass]="forecastFeedbackKind">{{ forecastFeedback }}</div>
    <div class="forecast-tip">
      <mat-icon>info</mat-icon>
      <span>Vincule a atividade do negocio no card quando aplicavel.</span>
    </div>
    </div>

    <div class="forecast-activities">
      <div class="forecast-activities-header">
        <h3>Atividades</h3>
        <button class="btn ghost small" type="button" (click)="addForecastActivity()">Adicionar atividade</button>
      </div>
      <article class="forecast-activity-card" *ngFor="let item of forecastActivities; let i = index">
        <div class="forecast-activity-head">
          <div>
            <strong>Atividade {{ i + 1 }}</strong>
            <small *ngIf="!item.linked || !item.activity_id">Geral</small>
          </div>
          <div class="forecast-activity-actions">
            <button class="btn ghost icon" type="button" (click)="toggleForecastActivity(i)">
              <mat-icon>{{ isForecastActivityExpanded(i) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            <button class="btn ghost small" type="button" (click)="removeForecastActivity(i)">Remover</button>
          </div>
        </div>
        <div class="forecast-activity-body" *ngIf="isForecastActivityExpanded(i)">
          <div class="form-grid forecast-activity-grid">
            <label class="toggle forecast-toggle">
              <input type="checkbox" [(ngModel)]="item.linked" (ngModelChange)="onForecastActivityLinkToggle(i)">
              <span>Vincular atividade do negocio</span>
            </label>
            <label *ngIf="item.linked; else fixedActivity">Atividade *
                <select [(ngModel)]="item.activity_id" (ngModelChange)="forecastValidationError = ''">
                  <option value="">Selecione</option>
                  <option *ngFor="let activity of forecastActivityOptions" [value]="activity.id">
                    {{ activity.title || 'Sem titulo' }}
                  </option>
                </select>
            </label>
            <ng-template #fixedActivity>
              <label>Atividade
                <input type="text" value="Geral" readonly>
              </label>
            </ng-template>
            <label *ngIf="!item.linked">Departamento *
              <select [(ngModel)]="item.department_id" (ngModelChange)="forecastValidationError = ''">
                <option value="">Selecione</option>
                <option *ngFor="let dept of scopedDepartmentsForControlopForms" [value]="dept.id">
                  {{ getDepartmentLabel(dept.id) }}
                </option>
              </select>
            </label>
            <label>Data recebido *
              <input type="date" [(ngModel)]="item.received_date">
            </label>
            <label>Mes/ano referencia *
              <input type="month" [(ngModel)]="item.reference_month">
            </label>
          </div>
          <div class="forecast-metrics-row">
            <label>Forecast mes *
              <input type="number" [(ngModel)]="item.forecast_month">
            </label>
            <label>Forecast semana
              <input type="number" [(ngModel)]="item.forecast_week">
            </label>
            <label>Forecast dia
              <input type="number" [(ngModel)]="item.forecast_day">
            </label>
            <label>Forecast hora
              <input type="number" [(ngModel)]="item.forecast_hour">
            </label>
          </div>
          <div class="forecast-notes">
            <label>Observacao
              <textarea rows="3" [(ngModel)]="item.notes"></textarea>
            </label>
          </div>
          <label class="forecast-dropzone">
            <input type="file" multiple (change)="onForecastAttachmentSelected(i, $event)" hidden>
            <mat-icon>cloud_upload</mat-icon>
            <div>
              <strong>Anexos</strong>
              <small>Arraste os arquivos aqui ou clique para selecionar.</small>
              <small *ngIf="item.newAttachments?.length">{{ item.newAttachments.length }} arquivo(s) selecionado(s)</small>
            </div>
          </label>
          <ul class="file-list" *ngIf="item.attachments?.length">
            <li *ngFor="let file of item.attachments">
              <a [href]="formatAttachmentUrl(file.path)" target="_blank" rel="noopener">
                {{ file.name || file.path }}
              </a>
            </li>
          </ul>
          <ul class="file-list" *ngIf="item.newAttachments?.length">
            <li *ngFor="let file of item.newAttachments">{{ file.name }}</li>
          </ul>
        </div>
      </article>
    </div>
  </div>
  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="closeForecastModal()">Cancelar</button>
    <button class="btn primary" type="button" (click)="submitForecast()">Salvar forecast</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showForecastHistoryModal" (click)="closeForecastHistoryModal()"></div>
<section class="modal" *ngIf="showForecastHistoryModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>Historico do forecast</h2>
      <p>Alteracoes registradas.</p>
    </div>
    <button type="button" class="close" (click)="closeForecastHistoryModal()">&times;</button>
  </header>
  <div class="cp-modal__body">
    <div class="history-list" *ngIf="forecastHistory.length; else emptyForecastHistory">
      <article class="history-item" *ngFor="let item of forecastHistory">
        <div class="history-head">
          <strong>{{ item.action === 'create' ? 'Criado' : 'Atualizado' }}</strong>
          <small>{{ item.created_at | date:'short' }}</small>
        </div>
        <p>{{ item.after_json?.title || item.before_json?.title || 'Forecast' }}</p>
        <div class="history-diff" *ngIf="item.before_json && item.after_json">
          <div class="diff-row">
            <span class="diff-label">Atividades</span>
            <span class="diff-before">{{ item.before_json?.activities?.length ?? 0 }}</span>
            <span class="diff-after">{{ item.after_json?.activities?.length ?? 0 }}</span>
          </div>
        </div>
      </article>
    </div>
    <ng-template #emptyForecastHistory>
      <div class="empty">Nenhuma alteracao registrada.</div>
    </ng-template>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showClosingModal" (click)="closeClosingModal()"></div>
<section class="modal" *ngIf="showClosingModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>{{ editingClosingId ? 'Editar fechamento' : 'Cadastrar fechamento' }}</h2>
      <p>Informe o departamento, data e resultados do periodo.</p>
    </div>
    <button type="button" class="close" (click)="closeClosingModal()">&times;</button>
  </header>
  <div class="cp-modal__body">
    <div class="cp-form-row">
      <label>Departamento *
        <select [(ngModel)]="closingForm.department_id">
          <option value="">Selecione</option>
          <option *ngFor="let dept of scopedDepartmentsForControlopForms" [value]="dept.id">
            {{ getDepartmentLabel(dept.id) }}
          </option>
        </select>
      </label>
      <label>Data *
        <input type="date" [(ngModel)]="closingForm.closing_date">
      </label>
      <label>Meta *
        <input type="number" [(ngModel)]="closingForm.goal" (ngModelChange)="updateClosingDeliveryPercent()">
      </label>
      <label>Realizado *
        <input type="number" [(ngModel)]="closingForm.achieved" (ngModelChange)="updateClosingDeliveryPercent()">
      </label>
      <label>% entrega *
        <input type="number" [(ngModel)]="closingForm.delivery_percent" readonly>
      </label>
    </div>
    <label>Observacao
      <textarea rows="3" [(ngModel)]="closingForm.notes"></textarea>
    </label>
    <div class="form-error" *ngIf="closingValidationError">{{ closingValidationError }}</div>
  </div>
  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="closeClosingModal()">Cancelar</button>
    <button class="btn primary" type="button" (click)="submitClosing()">Salvar fechamento</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showEmployeeModal" (click)="closeModals()"></div>
<section class="modal modal-card wide cp-employee-modal" *ngIf="showEmployeeModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>{{ selectedEmployee ? 'Editar colaborador' : 'Novo colaborador' }}</h2>
      <small>Preencha as informações pessoais e corporativas do colaborador.</small>
    </div>
    <button class="icon" type="button" (click)="closeModals()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="cp-modal-body">
    <div class="cp-tabs cp-employee-tabs">
      <button mat-stroked-button type="button" [class.active]="employeeTab === 'personal'" (click)="employeeTab = 'personal'">
        <mat-icon>badge</mat-icon>
        Dados pessoais
      </button>
      <button mat-stroked-button type="button" [class.active]="employeeTab === 'work'" (click)="employeeTab = 'work'">
        <mat-icon>business_center</mat-icon>
        Dados corporativos
      </button>
      <button mat-stroked-button type="button" [class.active]="employeeTab === 'links'" (click)="employeeTab = 'links'">
        <mat-icon>account_tree</mat-icon>
        Vínculos e estrutura
      </button>
      <button mat-stroked-button type="button" [class.active]="employeeTab === 'docs'" (click)="employeeTab = 'docs'">
        <mat-icon>attach_file</mat-icon>
        Documentos
      </button>
      <button mat-stroked-button type="button" [class.active]="employeeTab === 'extra'" (click)="employeeTab = 'extra'">
        <mat-icon>tune</mat-icon>
        Adicionais
      </button>
    </div>

    <div class="cp-modal-scroll">
      <section class="panel cp-project-modal-panel cp-employee-panel">
        <ng-container *ngIf="employeeTab === 'personal'">
          <fieldset [disabled]="!isAdmin">
            <div class="cp-form-row">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Nome completo</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.full_name">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Matrícula (opcional)</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.employee_code">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>CPF</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.cpf">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>RG</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.rg">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Data de nascimento</mat-label>
                <input matInput type="date" [(ngModel)]="employeeForm.birth_date">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Idade</mat-label>
                <input matInput type="text" [value]="getAgeLabel()" readonly>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Gênero</mat-label>
                <mat-select [(ngModel)]="employeeForm.gender">
                  <mat-option value="NOT_INFORMED">Selecione</mat-option>
                  <mat-option value="F">Feminino</mat-option>
                  <mat-option value="M">Masculino</mat-option>
                  <mat-option value="OTHER">Outro</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Estado civil</mat-label>
                <mat-select [(ngModel)]="employeeForm.marital_status">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let status of maritalStatusOptions" [value]="status">{{ status }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Local de nascimento</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.birth_location">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Raça/Cor</mat-label>
                <mat-select [(ngModel)]="employeeForm.race">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let option of raceOptions" [value]="option">{{ option }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Nome da mãe</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.mother_name">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Nome do pai</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.father_name">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Escolaridade</mat-label>
                <mat-select [(ngModel)]="employeeForm.education_level">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let option of educationLevelOptions" [value]="option">{{ option }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Telefone</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.phone">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>E-mail pessoal</mat-label>
                <input matInput type="email" [(ngModel)]="employeeForm.personal_email">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>CEP</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.cep">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Rua</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.street">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Número</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.number">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Complemento</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.complement">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Bairro</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.neighborhood">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Cidade</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.city">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Estado</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.state">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Contato de emergência</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.emergency_contact_name">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Telefone de emergência</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.emergency_contact_phone">
              </mat-form-field>
            </div>
          </fieldset>
        </ng-container>

        <ng-container *ngIf="employeeTab === 'work'">
          <fieldset [disabled]="!isAdmin">
            <div class="cp-form-row">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Status</mat-label>
                <mat-select [(ngModel)]="employeeForm.status">
                  <mat-option value="ACTIVE">Ativo</mat-option>
                  <mat-option value="INACTIVE">Inativo</mat-option>
                  <mat-option value="ON_LEAVE">Afastado</mat-option>
                  <mat-option value="TERMINATED">Desligado</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>E-mail corporativo</mat-label>
                <input matInput type="email" [(ngModel)]="employeeForm.corporate_email">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Data de admissão</mat-label>
                <input matInput type="date" [(ngModel)]="employeeForm.hired_at">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Cargo</mat-label>
                <mat-select [(ngModel)]="employeeForm.role_id" (ngModelChange)="onRoleChange()">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Experiência 45 dias</mat-label>
                <input matInput type="date" [(ngModel)]="employeeForm.experience_45_days" disabled>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Experiência 90 dias</mat-label>
                <input matInput type="date" [(ngModel)]="employeeForm.experience_90_days" disabled>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="isAdmin">
                <mat-label>Salário</mat-label>
                <input matInput type="number" step="0.01" [(ngModel)]="employeeForm.salary">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Tipo de contrato</mat-label>
                <mat-select [(ngModel)]="employeeForm.contract_type">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let option of contractTypeOptions" [value]="option">{{ option }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Código eSocial</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.esocial_code">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Número CTPS</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.ctps_number">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>PIS</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.pis">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>PCD</mat-label>
                <mat-select [(ngModel)]="employeeForm.pcd">
                  <mat-option [value]="0">Não</mat-option>
                  <mat-option [value]="1">Sim</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>CBO</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.cbo_code">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="isAdmin">
                <mat-label>Banco</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.bank">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="isAdmin">
                <mat-label>Agência</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.bank_branch">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="isAdmin">
                <mat-label>Conta</mat-label>
                <input matInput type="text" [(ngModel)]="employeeForm.bank_account">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="isAdmin">
                <mat-label>Tipo de conta</mat-label>
                <mat-select [(ngModel)]="employeeForm.bank_account_type">
                  <mat-option value="">Selecione</mat-option>
                  <mat-option *ngFor="let option of bankAccountTypes" [value]="option">{{ option }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </fieldset>
          <mat-form-field appearance="outline" class="digital-field modal-standard-field wide-field">
            <mat-label>Observações</mat-label>
            <textarea matInput rows="4" [(ngModel)]="employeeForm.notes" [disabled]="!isAdmin"></textarea>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="employeeTab === 'links'">
          <div class="cp-form-row">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Setor</mat-label>
              <mat-select [(ngModel)]="employeeForm.sector_id" (ngModelChange)="onSectorChange()" [disabled]="!isAdmin">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let sector of scopedSectors" [value]="sector.id">{{ sector.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Departamento</mat-label>
              <mat-select [(ngModel)]="employeeForm.department_id" (ngModelChange)="onDepartmentChange()">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let dept of availableDepartments" [value]="dept.id">{{ dept.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Local</mat-label>
              <mat-select [(ngModel)]="employeeForm.location_id">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let loc of availableLocations" [value]="loc.id">{{ loc.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="employeeTab === 'docs'">
          <div class="attachments-panel">
            <label
              class="dropzone full"
            >
              <input type="file" (change)="onAttachmentSelected($event)" [disabled]="!isAdmin">
              <div class="dropzone-content">
                <mat-icon>cloud_upload</mat-icon>
                <div class="cp-dropzone-text">
                  <span class="cp-dropzone-title">Adicionar documento</span>
                  <span class="cp-dropzone-hint">Arraste e solte aqui ou clique para selecionar.</span>
                </div>
              </div>
            </label>
            <div class="attachments-list">
              <h4>Anexos</h4>
              <div *ngIf="!attachments.length" class="empty">Nenhum anexo registrado.</div>
              <ul>
                <li *ngFor="let doc of attachments">
                  <a [href]="formatAttachmentUrl(doc.file_path)" target="_blank" rel="noopener">
                    {{ doc.file_name }}
                  </a>
                  <small>{{ doc.created_at | date:'short' }}</small>
                </li>
              </ul>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="employeeTab === 'extra'">
          <fieldset [disabled]="!isAdmin">
            <div class="cp-form-row">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Crachá</mat-label>
                <input matInput type="text" [(ngModel)]="extraForm.extra_json.badge_code" [disabled]="extraLoading">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Perfil de acesso</mat-label>
                <input matInput type="text" [(ngModel)]="extraForm.extra_json.access_profile" [disabled]="extraLoading">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Turno</mat-label>
                <input matInput type="text" [(ngModel)]="extraForm.extra_json.shift" [disabled]="extraLoading">
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Tamanho uniforme</mat-label>
                <input matInput type="text" [(ngModel)]="extraForm.extra_json.uniform_size" [disabled]="extraLoading">
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field wide-field">
              <mat-label>Observações adicionais</mat-label>
              <textarea matInput rows="4" [(ngModel)]="extraForm.extra_notes" [disabled]="extraLoading"></textarea>
            </mat-form-field>
            <div class="panel-actions" *ngIf="isAdmin">
              <button mat-stroked-button type="button" (click)="saveEmployeeExtras()" [disabled]="extraLoading || !selectedEmployee">
                {{ extraLoading ? 'Salvando...' : 'Salvar adicionais' }}
              </button>
            </div>
          </fieldset>
        </ng-container>
      </section>
    </div>
  </div>

  <div class="entry-footer">
    <button mat-stroked-button type="button" (click)="closeModals()">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="saveEmployee()">Salvar colaborador</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showOccurrenceModal" (click)="closeModals()"></div>
<section class="modal modal-card wide occurrence-modal" *ngIf="showOccurrenceModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Adicionar ocorrência</h2>
      <small>Colaborador: {{ selectedEmployee?.full_name }}</small>
    </div>
    <button class="icon" type="button" (click)="closeModals()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="cp-modal__body">
    <div class="cp-form-row">
      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Tipo de ocorrência</mat-label>
        <mat-select [(ngModel)]="occurrenceForm.type" (ngModelChange)="onOccurrenceTypeChange()">
          <mat-option value="ABSENCE">Falta</mat-option>
          <mat-option value="LATE">Atraso</mat-option>
          <mat-option value="JUSTIFICATION">Justificativa</mat-option>
          <mat-option value="WARNING_WRITTEN">Advertência escrita</mat-option>
          <mat-option value="WARNING_VERBAL">Advertência verbal</mat-option>
          <mat-option value="SUSPENSION">Suspensão</mat-option>
          <mat-option value="LEAVE">Afastamento</mat-option>
          <mat-option value="CERTIFICATE">Certificado</mat-option>
          <mat-option value="PROMOTION">Promoção de cargo</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Início</mat-label>
        <input matInput type="date" [(ngModel)]="occurrenceForm.start_date">
      </mat-form-field>
      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Fim</mat-label>
        <input matInput type="date" [(ngModel)]="occurrenceForm.end_date">
      </mat-form-field>
      <ng-container *ngIf="occurrenceForm.type === 'PROMOTION'">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Cargo promovido</mat-label>
          <mat-select [(ngModel)]="occurrenceForm.promoted_role_id">
            <mat-option value="">Selecione</mat-option>
            <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="isAdmin">
          <mat-label>Salário promovido</mat-label>
          <input matInput type="number" step="0.01" [(ngModel)]="occurrenceForm.promoted_salary">
        </mat-form-field>
      </ng-container>
    </div>
    <mat-form-field appearance="outline" class="digital-field modal-standard-field wide-field">
      <mat-label>Descrição</mat-label>
      <textarea matInput rows="3" [(ngModel)]="occurrenceForm.description"></textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" class="digital-field modal-standard-field wide-field">
      <mat-label>Observações</mat-label>
      <textarea matInput rows="3" [(ngModel)]="occurrenceForm.notes"></textarea>
    </mat-form-field>
    <div class="occurrence-attachments">
      <h4>Anexo da ocorrência</h4>
      <label
        class="dropzone full"
        [class.dragging]="occurrenceAttachmentDragging"
        (dragover)="onOccurrenceDragOver($event)"
        (dragleave)="onOccurrenceDragLeave($event)"
        (drop)="onOccurrenceFileDrop($event)"
      >
        <input #occurrenceFileInput type="file" (change)="onOccurrenceFileSelected($event)">
        <div class="dropzone-content">
          <mat-icon>attach_file</mat-icon>
          <div class="cp-dropzone-text">
            <span class="cp-dropzone-title">Adicionar anexo</span>
            <span class="cp-dropzone-hint">Arraste e solte aqui ou clique para selecionar.</span>
          </div>
        </div>
      </label>
      <small class="occurrence-file-hint">{{ occurrenceAttachmentName || 'Nenhum arquivo selecionado.' }}</small>
      <button mat-stroked-button type="button" *ngIf="occurrenceAttachmentName" (click)="clearOccurrenceAttachment()">
        Remover anexo
      </button>
    </div>
  </div>
  <div class="entry-footer">
    <button mat-stroked-button type="button" (click)="closeModals()">Cancelar</button>
    <button mat-raised-button color="primary" type="button" (click)="saveOccurrence()">Salvar ocorrência</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showHistoryModal" (click)="closeModals()"></div>
<section class="modal modal-card wide" *ngIf="showHistoryModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Histórico do colaborador</h2>
      <small>{{ selectedEmployee?.full_name }}</small>
    </div>
    <button class="icon" type="button" (click)="closeModals()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <div class="cp-modal__body">
    <section class="panel cp-history-panel">
      <div class="timeline">
        <div class="timeline-item" *ngFor="let item of pagedHistory">
          <div class="dot"></div>
          <div>
            <strong>{{ item.action_type }}</strong>
            <small>{{ item.created_at | date:'short' }}</small>
            <p>{{ item.description || '—' }}</p>
            <a
              *ngIf="item.attachment_path"
              class="history-attachment"
              [href]="formatAttachmentUrl(item.attachment_path)"
              target="_blank"
              rel="noopener"
            >
              {{ item.attachment_name || 'Baixar anexo' }}
            </a>
          </div>
        </div>
        <div *ngIf="!history.length" class="empty">Nenhum histórico registrado.</div>
      </div>
      <div class="table-pagination" *ngIf="history.length > historyPageSize">
        <button type="button" (click)="goToHistoryPage(historyPage - 1)" [disabled]="historyPage === 1">Anterior</button>
        <span>Página {{ historyPage }} de {{ historyTotalPages }}</span>
        <button type="button" (click)="goToHistoryPage(historyPage + 1)" [disabled]="historyPage === historyTotalPages">Próxima</button>
      </div>
    </section>
  </div>
  <div class="entry-footer">
    <button mat-stroked-button type="button" (click)="closeModals()">Fechar</button>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showEmployeeFeedbackModal" (click)="closeEmployeeFeedbackModal()"></div>
<section class="modal modal-card wide cad-feedback-employee-modal" *ngIf="showEmployeeFeedbackModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <h2>Feedback do colaborador</h2>
      <small *ngIf="employeeFeedbackTarget">
        {{ employeeFeedbackTarget.full_name }} · {{ employeeFeedbackTarget.role_name || 'Sem cargo' }}
      </small>
      <small *ngIf="!employeeFeedbackTarget">Selecione o template e registre a ação.</small>
    </div>
    <button class="icon" type="button" (click)="closeEmployeeFeedbackModal()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="cp-modal-body feedback-modal-body">
    <div class="cp-tabs feedback-tabs employee-feedback-tabs">
      <button
        mat-stroked-button
        type="button"
        *ngFor="let tab of employeeFeedbackTabs"
        [class.active]="employeeFeedbackTab === tab.value"
        (click)="onEmployeeFeedbackTabClick($event, tab.value)">
        <mat-icon>{{ tab.icon }}</mat-icon>
        {{ tab.label }}
      </button>
    </div>

    <div class="cp-modal-scroll">
      <section class="panel cp-project-modal-panel cp-employee-feedback-panel">
        <ng-container *ngIf="employeeFeedbackTab === 'REGISTRO'; else employeeFeedbackListView">
          <div class="cp-form-row feedback-main-grid employee-feedback-form-grid">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Template de feedback</mat-label>
              <mat-select [(ngModel)]="employeeFeedbackForm.feedback_template_id" (ngModelChange)="onEmployeeFeedbackTemplateChange($event)">
                <mat-option value="">Selecione</mat-option>
                <mat-option *ngFor="let item of availableEmployeeFeedbackTemplates" [value]="item.id">
                  {{ item.title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Agendar para</mat-label>
              <input matInput type="datetime-local" [(ngModel)]="employeeFeedbackForm.scheduled_for">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field feedback-full">
              <mat-label>Observações internas</mat-label>
              <textarea matInput rows="3" [(ngModel)]="employeeFeedbackForm.notes" placeholder="Observações internas do feedback"></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field feedback-full">
              <mat-label>Observações extras do colaborador</mat-label>
              <textarea matInput rows="3" [(ngModel)]="employeeFeedbackForm.collaborator_notes" placeholder="Observações adicionais do colaborador"></textarea>
            </mat-form-field>
            <small class="feedback-help feedback-full" *ngIf="!availableEmployeeFeedbackTemplates.length">
              Nenhum template disponível para o setor/departamento deste colaborador.
            </small>
          </div>

          <section class="feedback-question-builder employee-feedback-answer-builder">
            <div class="feedback-question-builder__header">
              <h3>Formulário de perguntas</h3>
              <small *ngIf="employeeFeedbackQuestions.length">{{ employeeFeedbackQuestions.length }} pergunta(s)</small>
            </div>

            <div class="loading" *ngIf="employeeFeedbackQuestionsLoading">Carregando perguntas...</div>
            <div class="empty" *ngIf="!employeeFeedbackQuestionsLoading && !employeeFeedbackForm.feedback_template_id">
              Selecione o template para responder o formulário.
            </div>
            <div class="empty" *ngIf="!employeeFeedbackQuestionsLoading && employeeFeedbackForm.feedback_template_id && !employeeFeedbackQuestions.length">
              Esse template não possui perguntas disponíveis.
            </div>

            <div class="feedback-question-list employee-feedback-answer-list" *ngIf="!employeeFeedbackQuestionsLoading && employeeFeedbackQuestions.length">
              <article class="feedback-question-card" *ngFor="let question of employeeFeedbackQuestions; let questionIndex = index">
                <div class="feedback-question-card__header">
                  <strong>Pergunta {{ questionIndex + 1 }}</strong>
                  <span *ngIf="question.required">Obrigatória</span>
                </div>
                <p class="feedback-answer-title">{{ question.title }}</p>
                <p class="feedback-answer-description" *ngIf="question.description">{{ question.description }}</p>

                <div class="feedback-answer-control" *ngIf="isEmployeeFeedbackChoiceQuestion(question)">
                  <select
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)">
                    <option value="">Selecione</option>
                    <option *ngFor="let option of question.options" [value]="employeeFeedbackOptionValue(option)">
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <div class="feedback-answer-control feedback-multi-options" *ngIf="isEmployeeFeedbackMultipleQuestion(question)">
                  <label class="feedback-multi-option" *ngFor="let option of question.options">
                    <input
                      type="checkbox"
                      [checked]="isEmployeeFeedbackOptionChecked(question.id, employeeFeedbackOptionValue(option))"
                      (change)="toggleEmployeeFeedbackOption(question.id, employeeFeedbackOptionValue(option), $any($event.target).checked)">
                    <span>{{ option.label }}</span>
                  </label>
                </div>

                <div class="feedback-answer-control" *ngIf="isEmployeeFeedbackNumberQuestion(question)">
                  <input
                    type="number"
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)"
                    placeholder="Digite um número">
                </div>

                <div class="feedback-answer-control" *ngIf="isEmployeeFeedbackDateQuestion(question)">
                  <input
                    type="date"
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)">
                </div>

                <div class="feedback-answer-control" *ngIf="isEmployeeFeedbackEmailQuestion(question)">
                  <input
                    type="email"
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)"
                    placeholder="nome@empresa.com">
                </div>

                <div class="feedback-answer-control" *ngIf="!isEmployeeFeedbackChoiceQuestion(question) && !isEmployeeFeedbackMultipleQuestion(question) && !isEmployeeFeedbackNumberQuestion(question) && !isEmployeeFeedbackDateQuestion(question) && !isEmployeeFeedbackEmailQuestion(question)">
                  <textarea
                    rows="3"
                    [ngModel]="employeeFeedbackQuestionAnswer(question.id)"
                    (ngModelChange)="setEmployeeFeedbackQuestionAnswer(question.id, $event)"
                    placeholder="Digite a resposta"></textarea>
                </div>
              </article>
            </div>
          </section>
        </ng-container>

        <ng-template #employeeFeedbackListView>
          <div class="feedback-table-wrap employee-feedback-table">
            <div class="loading" *ngIf="employeeFeedbackLoading">Carregando registros...</div>
            <table *ngIf="!employeeFeedbackLoading && filteredEmployeeFeedbackRecords.length">
              <thead>
                <tr>
                  <th>Template</th>
                  <th>Status</th>
                  <th>Agendado para</th>
                  <th>Aplicado em</th>
                  <th>Criado em</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of filteredEmployeeFeedbackRecords">
                  <td>
                    <strong>{{ row.template_title || 'Template removido' }}</strong>
                    <small *ngIf="row.notes">{{ row.notes }}</small>
                  </td>
                  <td>{{ employeeFeedbackStatusLabel(row.status) }}</td>
                  <td>{{ row.scheduled_for ? (row.scheduled_for | date:'short') : '—' }}</td>
                  <td>{{ row.applied_at ? (row.applied_at | date:'short') : '—' }}</td>
                  <td>{{ row.created_at ? (row.created_at | date:'short') : '—' }}</td>
                  <td class="feedback-table-actions">
                    <button class="btn ghost small" type="button" (click)="editEmployeeFeedbackRecord(row)">Editar</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="empty" *ngIf="!employeeFeedbackLoading && !filteredEmployeeFeedbackRecords.length">
              Nenhum registro em {{ employeeFeedbackStatusLabel(employeeFeedbackTab).toLowerCase() }}.
            </div>
          </div>
        </ng-template>

        <div class="feedback-inline-error" *ngIf="employeeFeedbackError">{{ employeeFeedbackError }}</div>
      </section>
    </div>
  </div>

  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="closeEmployeeFeedbackModal()">Fechar</button>
    <ng-container *ngIf="employeeFeedbackTab === 'REGISTRO'">
      <button class="btn ghost" type="button" [disabled]="employeeFeedbackSaving" (click)="saveEmployeeFeedback('DRAFT')">
        {{ employeeFeedbackSaving ? 'Salvando...' : 'Salvar rascunho' }}
      </button>
      <button class="btn ghost" type="button" [disabled]="employeeFeedbackSaving" (click)="saveEmployeeFeedback('SCHEDULED')">
        {{ employeeFeedbackSaving ? 'Salvando...' : 'Agendar' }}
      </button>
      <button class="btn primary" type="button" [disabled]="employeeFeedbackSaving" (click)="saveEmployeeFeedback('APPLIED')">
        {{ employeeFeedbackSaving ? 'Salvando...' : 'Aplicar' }}
      </button>
    </ng-container>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showRoleModal" (click)="closeModals()"></div>
<section class="modal" *ngIf="showRoleModal" (click)="$event.stopPropagation()">
  <header>
    <h2>{{ editingRole ? 'Editar cargo' : 'Novo cargo' }}</h2>
    <button type="button" class="close" (click)="closeModals()">&times;</button>
  </header>
  <label>Nome do cargo
    <input type="text" [(ngModel)]="roleForm.name">
  </label>
  <label *ngIf="isAdmin">Salário base
    <input type="number" step="0.01" [(ngModel)]="roleForm.base_salary">
  </label>
  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="closeModals()">Cancelar</button>
    <button class="btn primary" type="button" (click)="saveRole()">
      {{ editingRole ? 'Salvar alterações' : 'Salvar cargo' }}
    </button>
  </div>
  <div class="role-list">
    <h4>Cargos cadastrados</h4>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th *ngIf="isAdmin">Salário</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let role of roles">
            <td>{{ role.name }}</td>
            <td *ngIf="isAdmin">{{ role.base_salary || '—' }}</td>
            <td class="actions">
              <button type="button" (click)="editRole(role)">Editar</button>
            </td>
          </tr>
          <tr *ngIf="!roles.length">
            <td [attr.colspan]="isAdmin ? 3 : 2" class="empty">Nenhum cargo cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>

<div class="modal-backdrop" *ngIf="showImportModal" (click)="closeModals()"></div>
<section class="modal wide" *ngIf="showImportModal" (click)="$event.stopPropagation()">
  <header>
    <div>
      <h2>Importar base</h2>
      <p>Selecione a planilha e valide os dados antes de importar.</p>
    </div>
    <button type="button" class="close" (click)="closeModals()">&times;</button>
  </header>
  <div class="import-uploader">
    <input type="file" accept=".csv,.xlsx" (change)="handleImportFile($event)">
    <small>{{ importFileName || 'Nenhum arquivo selecionado' }}</small>
  </div>
  <div class="import-preview" *ngIf="importPreviewRows.length">
    <h4>Preview da planilha</h4>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th *ngFor="let header of importHeaders">{{ header }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of importPreviewRows">
            <td *ngFor="let header of importHeaders">{{ row[header] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="import-feedback" *ngIf="importFeedback">
    <strong>{{ importFeedback }}</strong>
    <div class="error-list" *ngIf="importErrorRows.length">
      <p>Linhas com erro:</p>
      <ul>
        <li *ngFor="let row of importErrorRows.slice(0, 10)">
          Linha {{ row.row_index }} · {{ row.__error || 'Erro de validação' }}
        </li>
      </ul>
      <small *ngIf="importErrorRows.length > 10">Mostrando 10 primeiros erros.</small>
    </div>
  </div>
  <div class="entry-footer">
    <button class="btn ghost" type="button" (click)="closeModals()">Cancelar</button>
    <button class="btn primary" type="button" [disabled]="importLoading || !importPreviewRows.length" (click)="confirmImport()">
      {{ importLoading ? 'Importando...' : 'Confirmar importação' }}
    </button>
  </div>
</section>
